import {
  FaCubes,
  FaUsers,
  FaUserShield,
  FaChartLine,
  FaServer,
  FaSyncAlt,
  FaCodeBranch,
  FaEye,
} from "@onemind-services-llc/react-icons-ng/fa";
import SeparatorImg from "public/openStack/features/featuresSeparator.png";

export const kubernetesKeyFeatures = {
  TITLE: "Key Features",
  ITEMS: [
    {
      title: "CNCF-Compliant K8s",
      content:
        "100% upstream Kubernetes—fully compatible with Helm, kubectl, and K8s APIs.",
      icon: FaCubes,
    },

    {
      title: "Role-Based Access Control",
      content: "Secure your cluster with fine-grained RBAC policies.",
      icon: FaUserShield,
    },

    {
      title: "Cluster Auto-Scaler",
      content: "Scale nodes dynamically to match workload demands.",
      icon: FaSyncAlt,
    },
    {
      title: "GitOps-Ready",
      content: "Compatible with ArgoCD and Flux for continuous delivery pipelines.",
      icon: FaCodeBranch,
    },

    {
      title: "Public Cluster Support",
      content: "Share clusters across teams while isolating workloads via namespaces.",
      icon: FaUsers,
    },
    {
      title: "Horizontal Pod Autoscaling",
      content: "Automatically adjust resources based on real-time metrics.",
      icon: FaChartLine,
    },
    {
      title: "Zero Downtime Upgrades",
      content: "Rolling updates for nodes and workloads to avoid service interruptions.",
      icon: FaServer,
    },
    {
      title: "Integrated Monitoring",
      content: "View workloads, node metrics, and health in a unified dashboard.",
      icon: FaEye,
    },
  ],
  SEPARATOR_IMG: SeparatorImg,
  CARD_HEIGHT: "195px",
};
